import * as React from 'react';
import ShiftHistoryViewModel from './Viewmodels/ShiftHistoryViewModel';
import TableRow from '@mui/material/TableRow';
import TableCell from '@mui/material/TableCell';

interface IProps {
    row: ShiftHistoryViewModel;
}

export default function ShiftHistoryTableRow({ row }: IProps) {
    return (
        <TableRow>
            <TableCell>{row.name}</TableCell>
            <TableCell>{row.startDate ? new Date(row.startDate).toLocaleDateString('en-GB', { day: "2-digit", month: "2-digit", year: "numeric" }) : '-'}</TableCell>
            <TableCell>{row.endDate ? new Date(row.endDate).toLocaleDateString('en-GB', { day: "2-digit", month: "2-digit", year: "numeric" }) : '-'}</TableCell>
        </TableRow>
    );
}